module.exports = __webpack_public_path__ + "img/oneclickmoney.314b38dd.svg";